{
  "comment": "M7 spec §2.4–§2.5 (S8 owns): per link L = min(1, Σ bundle weights / linkCap); evidenceWeight = meanScale × mean(L) + testimony − credibility, clamped 0..1. Originals weigh weights.original, logs weights.log, sold-item copies × copyMult, texture 0. Credibility penalties stack to credibility.cap. Case line: rumour below caseLine.circumstantial, documented from caseLine.documented, damning from caseLine.damning. Meter proofs: one per distinct Tethys operation per meter.windowDays faction days, at most meter.maxInCase. Repeatable corroboration: weight, once per everyOnlineDays online days, at most maxPerLink per link (the fees are not in the spec: placeholders). Placeholders for the balance pass (M7 spec §15 item 4); tune freely. S8: linkCap 6 → 5 (D-TBD) so T7 holds inside the 8-entry bundle without testimony: with manifest_sold and hale_deal, the best bundle reaches ≈ 0.52 (6 would give ≈ 0.43). Bundle entries are a log id, a story item id, or a repeatable instance '<template>#<n>'; an item entry carries every log of that item (the report core supports both knowledge and coverup).",
  "linkCap": 5,
  "meanScale": 0.8,
  "weights": {
    "original": 3,
    "log": 1,
    "copyMult": 0.33,
    "texture": 0
  },
  "testimony": {
    "okaforPublic": 0.15,
    "okaforAnonymous": 0.05,
    "duarte": 0.05
  },
  "credibility": {
    "stipendKnown": 0.1,
    "sponsorGuardian": 0.1,
    "cap": 0.2
  },
  "caseLine": {
    "circumstantial": 0.25,
    "documented": 0.5,
    "damning": 0.75
  },
  "bundleMax": 8,
  "meter": {
    "windowDays": 10,
    "maxInCase": 2
  },
  "corroboration": {
    "weight": 1,
    "everyOnlineDays": 10,
    "maxPerLink": 2,
    "fees": {
      "order": 5000,
      "knowledge": 0,
      "coverup": 0,
      "complicity": 5000
    },
    "templates": {
      "order": "evacuation.corr_insurance_claim",
      "knowledge": "watch.corr_meter_reading",
      "coverup": "report.corr_transfer_order",
      "complicity": "settlement.corr_50a_extract"
    }
  }
}
